import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  tokenValue = new BehaviorSubject<boolean>(false);
  constructor(private readonly httpClient: HttpClient,
    private readonly oauthService: OAuthService) { }

  executeGET<T extends object>(url: string, headers: HttpHeaders = this.getTokenHeadersWithoutAuth()): Observable<T> {
    return this.httpClient.get<T>(url, { headers });
  }

  executePOST<T extends object>(url: string, body: object, headers: HttpHeaders = this.getTokenHeaders()): Observable<T> {
    return this.httpClient.post<T>(url, body, { headers });
  }
  
  executePOSTFullResponse<T extends object>(url: string, body: object, headers: HttpHeaders = this.getTokenHeaders()): Observable<HttpResponse<T>> {
    return this.httpClient.post<T>(url, body, { headers, observe: 'response' });
  }

  executePUT<T extends object>(url: string, body: object): Observable<T> {
    const headers = this.getTokenHeaders();
    return this.httpClient.put<T>(url, body, { headers });
  }
  executeGETQueryWithParams<T extends object>(makeSureThisIsAFhirQuery: string): Observable<T> {
    const headers = this.getTokenHeaders();
    return this.httpClient.get<T>(makeSureThisIsAFhirQuery, { headers });
  }

  executeGETQueryWithParamsWithoutAuth<T extends object>(makeSureThisIsAFhirQuery: string): Observable<T> {
    const headers = this.getTokenHeadersWithoutAuth();
    return this.httpClient.get<T>(makeSureThisIsAFhirQuery, { headers });
  }

  getTokenHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oauthService.getAccessToken(),
      "Content-Type": "application/fhir+json"
    });
    return headers;
  }

  getTokenHeadersWithoutAuth(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/fhir+json"
    });
    return headers;
  }

}
